import { useBaseViewModel } from '@/common';
import {
  QueryCourseTopicPayload,
  QueryCourseTopicsOutput,
} from '@/domains/course-topic/ports/payloads';
import { GetListCourseTopicUsecase } from '@/domains/course-topic/usecases';
import { useState } from 'react';
import { CourseTopicHttpRepository } from '../adapters/repositories';

export default function GetListCourseTopic() {
  const getListCourseTopicUC = new GetListCourseTopicUsecase(new CourseTopicHttpRepository());
  const { loading, error, catchAction } = useBaseViewModel();
  const [courseTopicData, setCourseTopicData] = useState<QueryCourseTopicsOutput>();

  const actionGetAllCourseTopic = async (payload?: QueryCourseTopicPayload) => {
    await catchAction(async () => {
      const data = await getListCourseTopicUC.run(payload);
      setCourseTopicData(data);
    });
  };

  return {
    loading,
    error,
    courseTopicData,
    actionGetAllCourseTopic,
  };
}
